import apiClient from './Client';

export interface Project {
  associatedProductID: number;
  projectName: string | null;
  productType: string;
  lastModified: string | null;
  productBasePrice: number;
  productImageUrl: string | "";
  productId: number;
  status: string;
  width: number;
  height: number;
  projectDesc: string | null;
}

class MyAccountService {
  async GetMyProjects(ProductType: string = 'all'): Promise<Project[]> {
    console.log('GetMyProjects with productType:', ProductType);
    try {
      const response = await apiClient.get<Project[]>(`/MyProjects/get-my-projects/${ProductType}`);
        return response.data;
    } catch (err: any) {
        console.error(err);
        return [];
    }
  }
 
  async DeleteProject(ProductType: string, AssociatedProductID: number){    
    try {
      const response = await apiClient.delete(`/MyProjects/${ProductType}/${AssociatedProductID}`);
      return response;
    } catch (error) {
      
    }
  }

}

export default new MyAccountService();
